(ns minorodata.vcs.subs
  (:require [re-frame.core :as re-frame]))

;; Returns the self-scoped GitHub user-link status map (namespaced keys:
;; :vcs-user-link/github-enabled, :vcs-user-link/connected,
;; :vcs-user-link/login, :vcs-user-link/provider), or nil before the first
;; fetch. Derives from the vcs-user-link singleton pull (auto-generated by
;; mold defmodel).
(re-frame/reg-sub
 :vcs.subs/user-link-status
 (fn [_]
   (re-frame/subscribe [:vcs-user-link/pull]))
 (fn [link _]
   link))
